export const NAV_COLLAPSED = 'NAV_COLLAPSED';
export const Actions={
	SET_NAV_COLLAPSED : 'SET_NAV_COLLAPSED'
}

export const setNavCollapsed=(navCollapsed: boolean)=> 
	(dispatch:any) =>
	 {
		dispatch({
		type:Actions.SET_NAV_COLLAPSED,
		payload:  navCollapsed        
		});
	};
